module.exports = __webpack_public_path__ + "media/images/emblems/Sagogn_wappen-4b32b64cee94a01219badd64ad9be2da.svg";